import React from 'react'
import { Icon, Input, message, Tooltip } from 'antd'

export default class EditableBudget extends React.Component {

    state = {}

    componentDidMount() {
        const { value, month, record, editable } = this.props
        this.setState({ value, month, record, editable })
    }

    on_toggle = () => this.setState(({is_editing}) => ({is_editing: !is_editing}))

    on_change = ({ target }) => this.setState({value: target.value})

    on_save = () => {
        const { value } = this.state
        if (!value) {
            message.error('Enter a valid budget.')
            this.on_toggle()
        } else {
            this.props.on_save(value, this.props.record, this.props.month)
            this.on_toggle()
        }
    }

    on_close = () => {
        this.setState({ value: this.props.value })
        this.on_toggle()
    }

    render() {
        const {value, editable}  = this.state
        const {show_yellow_alert} = this.props
        return (
            <div className='editable-budget'>
                {
                    this.state.is_editing && editable ? ([
                        <Input key='input' value={value} size='small' type='number'
                               onChange={this.on_change} onKeyDown={e => {
                            if (e.keyCode === 13) this.on_save()
                            if (e.keyCode === 27) this.on_close()
                        }} />,
                    ]) : ([
                        <Tooltip key='warn'
                                 title='Warning: sub budgets does not match total budget'>
                            <div className='warning' style={show_yellow_alert ? { visibility: 'visible' } : {}} />
                        </Tooltip>,
                        editable &&
                        <span key='value' onDoubleClick={this.on_toggle}>{value ? this.props.format_price(value) : '------'}</span>
                    ])
                }
            </div>
        )
    }
}